import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { debounce, dup } from 'modules/utils';

class LanguageDictionaryOption extends Component {
  static propTypes = {
    onChange: PropTypes.func.isRequired,
    value: PropTypes.object.isRequired
  }

  constructor(props) {
    super(props);

    this.onChange = debounce((name, value) => {
      const languageDictionary = dup(this.props.value);
      languageDictionary[name] = value;
      this.props.onChange('languageDictionary', languageDictionary);
    }, 400);
  }

  renderItem(name, value) {
    return (
      <li className="line-row" key={name}>
        <span>
          {name}:
          <input
            className="text-input"
            defaultValue={value}
            onChange={e => this.onChange(name, e.target.value)}
          />
        </span>
      </li>
    );
  }

  render() {
    const { value } = this.props;

    return (
      <div className="line-row">
        <li className="line-row">
          <span>
            languageDictionary: {'{'}
          </span>
        </li>
        {global.Object.keys(value).map(k => this.renderItem(k, value[k]))}
        <li className="line-row">
          <span>
            {'}'}
          </span>
        </li>
      </div>
    );
  }
}

export default LanguageDictionaryOption;



// WEBPACK FOOTER //
// ./src/components/EditorOption/LanguageDictionaryOption.js


// WEBPACK FOOTER //
// webpack:///src/components/EditorOption/LanguageDictionaryOption.js